<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="(size*13)/17"
    viewBox="0 0 17 13"
  ><g><g><path
    :fill="color"
    d="M14.978 10.641l-4.17-4.17 4.17-4.17zm-12.493.615l4.193-4.192L8.147 8.52c.17.169.444.168.614-.001l1.432-1.433 4.17 4.17zm-.615-.615V2.297l4.19 4.154zm12.493-8.955L8.452 7.597l-5.963-5.91zm.18-.87H2.305C1.586.816 1 1.402 1 2.121v8.7c0 .717.584 1.305 1.305 1.305h12.238c.717 0 1.305-.583 1.305-1.305v-8.7c0-.717-.584-1.305-1.305-1.305z"
  /><path
    fill="none"
    :stroke="color"
    stroke-miterlimit="50"
    stroke-width=".3"
    d="M14.978 10.641l-4.17-4.17 4.17-4.17zm-12.493.615l4.193-4.192L8.147 8.52c.17.169.444.168.614-.001l1.432-1.433 4.17 4.17zm-.615-.615V2.297l4.19 4.154zm12.493-8.955L8.452 7.597l-5.963-5.91zm.18-.87H2.305C1.586.816 1 1.402 1 2.121v8.7c0 .717.584 1.305 1.305 1.305h12.238c.717 0 1.305-.583 1.305-1.305v-8.7c0-.717-.584-1.305-1.305-1.305z"
  /></g></g></svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3B334A',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
